import { render } from "./OidoTabs.vue?vue&type=template&id=3e0ee527&scoped=true"
import script from "./OidoTabs.vue?vue&type=script&lang=js"
export * from "./OidoTabs.vue?vue&type=script&lang=js"

import "./OidoTabs.vue?vue&type=style&index=0&id=3e0ee527&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0ee527"]])

export default __exports__